/******
 *
 * Post 관련 API
 ******/
import Request from "@/utils/Request";

export default {
  /*
  Post get func
  인덱스 렌더 시 크롤링된 포스트들을 가지고 옴

  220621 작업내용 : DB에서 Data를 가지고 옴
  변경사항 : url "/post/" 에서 "/SimpleEntry/getBlogContents"로 수정
  */
  getList() {
    return Request({
      url: "/SimpleEntry/getBlogContents",
      method: "get"
    });
  },
// 220621 이관작업 전 기존 소스코드 주석화 - 임시보관
  // getList() {
  //   return Request({
  //     url: "/post/",
  //     method: "get"
  //   });
  // },
  /*
  Get Version func

  서버에 등록되어있는 버전과 비교용으로 사용함
  서버와 빌드된 프로젝트의 버전이 다를 시 캐시 삭제 후 재렌더함
   */
  getVersion() {
    return Request({
      url: "/SimpleEntry/getVersion/"+"R",//"/post/get_version",
      method: "get"
    });
  }
};
